import React, { useState, useEffect } from "react";
import { useCurrentPolicyContext } from "../../actions/CurrentPolicyContext";
import { useLoadingContext } from "../../Loading/LoadingContext";
import { getSingleData } from "../../Utils/CallApiUtils";
import { convertDateFormatWithSeconds } from "../../Utils/commonFunction";
import DetailCard, { statusTone } from "../../Common/DetailCard";
import EmptyState from "../../Common/EmptyState";
import "./DetailSheet.css";

export default function Courier() {
  const { currentSelectPolicyID, currentSelectPolicyNo } =
    useCurrentPolicyContext();
  const [CourierData, setCourierData] = useState([]);
  const { setIsLoading } = useLoadingContext();

  useEffect(() => {
    if (currentSelectPolicyID > 0) {
      getCourierDetail();
    } else {
      window.location = "/";
    }
  }, [currentSelectPolicyID]);

  const getCourierDetail = async () => {
    await getSingleData(
      `Courier/AllCourierDetailModel?PolicyID=${currentSelectPolicyID}`,
      setCourierData,
      setIsLoading
    );
  };

  if (CourierData.length === 0) {
    return (
      <EmptyState
        icon="fa-truck-fast"
        title="Nothing has been couriered yet"
        text="When your documents are dispatched, the tracking number and its status will appear here."
        meta={currentSelectPolicyNo && `Policy Number : ${currentSelectPolicyNo}`}
      />
    );
  }

  return (
    <div className="sheet">
      {CourierData.map((item, index) => (
        <DetailCard
          key={item.trackingNumber || index}
          eyebrow="Tracking number"
          /* The tracking number leads: it is the one value on this card a
             customer might read out or copy. */
          title={item.trackingNumber || "Not assigned"}
          meta={`Policy Number : ${item.policyNo || currentSelectPolicyNo || "—"}`}
          chip={item.courierStatus}
          chipTone={statusTone(item.courierStatus)}
          facts={[
            { label: "Courier", value: item.courierName },
            {
              label: "Dispatched",
              value:
                item.dispatchedDateTime &&
                convertDateFormatWithSeconds(item.dispatchedDateTime),
            },
          ]}
          /* The link is built server-side from the courier company's own tracking
             template. It was hardcoded to Anjani, so a consignment sent by any other
             courier took the customer to a site that had never heard of their tracking
             number. Gated on trackingLink rather than trackingNumber: with no template
             configured there is no link to offer, and a dead link is worse here than
             no button at all. */
          actions={
            item.trackingLink && (
              <a
                className="dcard__link dcard__link--track"
                href={item.trackingLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-location-dot" aria-hidden="true"></i>
                Track this shipment
              </a>
            )
          }
        />
      ))}
    </div>
  );
}
